(() => {
  // transService.js
  const transService = {
    // 應用所有篩選條件
    classClassificationMap: {},
    airlineMap: {},
    departureMap: {
      deptEng: {
        基隆港: "KEL",
        松山: "TSA",
        桃園: "TYC",
        台中: "RMQ",
        台南: "TNN",
        高雄: "KHH",
        台北: "TPE",
        嘉義: "CYI",
        "": "TWN",
        富岡碼頭: "TMK",
        東港碼頭: "DGG",
        布袋港: "PDI",
        南港: "STP",
        中壢: "ZGL",
        豐原: "FYN",
        彰化: "CGH",
        苗栗: "MLI",
        金門: "KMN",
        澎湖: "PEH",
        花蓮: "HWA",
        台東: "TTT",
        高雄港: "KAO",
        台北港: "TPC",
      },
      AirPT: {
        中正機場第一航站: "桃園",
        中正機場第二航站: "桃園",
        台北桃園機場: "桃園",
        台灣桃園國際機場: "桃園",
        桃園國際機場: "桃園",
        松山機場: "松山",
        台北松山機場: "松山",
        台中清泉崗機場: "台中",
        台中國際機場: "台中",
        台南機場: "台南",
        高雄小港機場: "高雄",
        基隆港: "基隆港",
        嘉義機場: "嘉義",
        x: "國內",
        "": "國內",
        富岡碼頭: "富岡碼頭",
        東港碼頭: "東港碼頭",
        布袋港: "布袋港",
        高雄港: "高雄",
        台北: "台北",
        台中: "台中",
        台南: "台南",
        高雄: "高雄",
        南港: "南港",
        中壢: "中壢",
        桃園: "桃園",
        豐原: "豐原",
        彰化: "彰化",
        金門尚義機場: "金門",
        澎湖馬公機場: "澎湖",
        花蓮機場: "花蓮",
        豐年機場: "台東",
        台北港: "台北港",
      },
      AirSort: {
        基隆港: 1,
        台北: 2,
        台北港: 3,
        南港: 4,
        中壢: 5,
        松山: 6,
        桃園: 7,
        豐原: 8,
        台中: 9,
        彰化: 10,
        嘉義: 15,
        布袋港: 16,
        台南: 17,
        高雄: 18,
        國內: 19,
        富岡碼頭: 20,
        東港碼頭: 21,
        金門: 22,
        澎湖: 23,
        花蓮: 24,
        台東: 25,
        高雄港: 30,
        安平碼頭: 33,
      },
    },
    convertArrayToDictionary(jsonArray) {
      const dictionary = {};
      jsonArray.forEach((item) => {
        // Add entry for classification
        const classificationKey = item.classification;
        const classificationValue =
          item.showClassNm && item.showClassNm.trim() !== ""
            ? item.showClassNm
            : item.classificationName;
        dictionary[classificationKey + item.subClassification] =
          classificationValue;

        // Add entry for subClassification
        const subClassificationKey = item.subClassification;
        const subClassificationValue =
          item.showField && item.showField.trim() !== ""
            ? item.showField
            : item.subClassificationName;
        dictionary[subClassificationKey] = subClassificationValue;
      });
      this.classClassificationMap = dictionary;
      return dictionary;
    },
    convertAirlinesToDictionary(jsonArray) {
      const dictionary = {};
      jsonArray.forEach((item) => {
        // Add entry for classification
        const airlineKey = item.airlineCode;
        const airlineValue = item.airline;
        dictionary[airlineKey] = airlineValue;
      });
      this.airlineMap = dictionary;
      return dictionary;
    },
    transGroupStatus(jsonArray) {
      return jsonArray.map((group) => {
        group.groups = group.groups.map((groupItem) => {
          if (new Date(groupItem.orderDeadline) < new Date()) {
            groupItem.status = 1;
          } else if (groupItem.hotType === "7") {
            groupItem.status = 2;
          } else if (groupItem.waitSeat >= groupItem.remainSeat || groupItem.remainSeat <= 0) {
            groupItem.status = 3;
          } else if (groupItem.hotType === "6") {
            groupItem.status = 5;
          } else if (groupItem.hotType === "2") {
            groupItem.status = 7;
          } else if (groupItem.hotType === "8") {
            groupItem.status = 8;
          } else {
            groupItem.status = 7;
          }
          return groupItem;
        });
        return group;
      });
    },
    sortGroups(groups, areaNameOrder, classes) {
      // 將 areaName 排序字串轉換為排序映射
      const areaNameOrderMap = (areaNameOrder || "")
        .split("|")
        .reduce((map, area, index) => {
          map[area] = index;
          return map;
        }, {});

      // 將 subArea 排序陣列轉換為排序映射
      const subAreaOrderMap = classes.reduce((map, cls) => {
        map[cls.subClassification] = cls.orderByValue;
        return map;
      }, {});

      // 對 groups 陣列進行排序
      return [...groups].sort((a, b) => {
        // 1. 依照 areaName 排序
        const areaNameOrderA =
          areaNameOrderMap[this.classClassificationMap[a.area + a.subArea]] !==
          undefined
            ? areaNameOrderMap[this.classClassificationMap[a.area + a.subArea]]
            : Number.MAX_SAFE_INTEGER;
        const areaNameOrderB =
          areaNameOrderMap[this.classClassificationMap[b.area + b.subArea]] !==
          undefined
            ? areaNameOrderMap[this.classClassificationMap[b.area + b.subArea]]
            : Number.MAX_SAFE_INTEGER;
        if (areaNameOrderA !== areaNameOrderB) {
          return areaNameOrderA - areaNameOrderB;
        }

        // 2. 依照 subArea 排序
        const subAreaOrderA =
          subAreaOrderMap[a.subArea] !== undefined
            ? subAreaOrderMap[a.subArea]
            : Number.MAX_SAFE_INTEGER;
        const subAreaOrderB =
          subAreaOrderMap[b.subArea] !== undefined
            ? subAreaOrderMap[b.subArea]
            : Number.MAX_SAFE_INTEGER;
        if (subAreaOrderA !== subAreaOrderB) {
          return subAreaOrderA - subAreaOrderB;
        }

        // 3. 依照 departureSort 排序
        if (a.departureSort !== b.departureSort) {
          return a.departureSort - b.departureSort;
        }

        // 4. 最後依照 orderByValue 排序

        return a.orderByValue - b.orderByValue;
      });
    },

    createGroupedStructure(data, groupShowType, sorts) {
      // 篩選出類型為 "Group" 的資料
      const filteredData = _.filter(data, (item) => item.type === "Group");

      // 第一步：建立區域分組
      const areaGroups = [];
      const areaMap = {};

      // 按順序處理每個項目
      _.forEach(filteredData, (item) => {
        const areaName =
          this.classClassificationMap[item.area + item.subArea] ||
          item.areaName;
        const subArea =
          this.classClassificationMap[item.subArea] || item.subArea;
        const otherAreaKey = item.otherArea || "null";

        // 檢查該區域是否已經存在於我們的結果中
        let areaGroup = areaMap[areaName];
        if (!areaGroup) {
          areaGroup = {
            areaName: areaName,
            items: [],
            subAreas: [],
            subAreaMap: {},
          };
          areaMap[areaName] = areaGroup;
          areaGroups.push(areaGroup);
        }

        // 檢查子區域是否已經存在
        let subAreaGroup = areaGroup.subAreaMap[subArea];
        if (!subAreaGroup) {
          subAreaGroup = {
            subArea: subArea,
            items: [],
            otherAreas: [],
            otherAreaMap: {},
          };
          areaGroup.subAreaMap[subArea] = subAreaGroup;
          areaGroup.subAreas.push(subAreaGroup);
        }

        // 檢查其他區域是否已經存在
        let otherAreaGroup = subAreaGroup.otherAreaMap[otherAreaKey];
        if (!otherAreaGroup) {
          otherAreaGroup = {
            otherArea: otherAreaKey === "null" ? null : otherAreaKey,
            otherAreaName: item.otherAreaName || "",
            items: [],
            departureGroups: [],
            departureMap: {},
          };
          subAreaGroup.otherAreaMap[otherAreaKey] = otherAreaGroup;
          subAreaGroup.otherAreas.push(otherAreaGroup);
        }

        // 添加項目到各個層級
        otherAreaGroup.items.push(item);
        subAreaGroup.items.push(item);
        areaGroup.items.push(item);

        // 處理出發點分組
        const departureCode = item.departureCode;
        let departureGroup = otherAreaGroup.departureMap[departureCode];
        if (!departureGroup) {
          departureGroup = {
            subArea: subArea,
            departureCode: departureCode,
            departure: item.departure,
            items: [],
          };
          otherAreaGroup.departureMap[departureCode] = departureGroup;
          otherAreaGroup.departureGroups.push(departureGroup);
        }
        departureGroup.items.push(item);
      });

      // 對 otherAreas 進行排序
      _.forEach(areaGroups, (areaGroup) => {
        _.forEach(areaGroup.subAreas, (subAreaGroup) => {
          // 依據 otherAreaSort 排序 otherAreas
          if (subAreaGroup.otherAreas.length > 1) {
            subAreaGroup.otherAreas = subAreaGroup.otherAreas.map((item) => {
              return {
                ...item,
                otherAreaName: item.otherAreaName || "精選行程",
              };
            });
          }

          subAreaGroup.otherAreas = _.sortBy(
            subAreaGroup.otherAreas,
            (otherArea) => {
              return otherArea.items[0]?.otherAreaSort ?? 9999;
            },
          );

          // 處理每個 otherArea 內的 departureGroups
          _.forEach(subAreaGroup.otherAreas, (otherArea) => {
            if (groupShowType === "uni") {
              _.forEach(otherArea.departureGroups, (departureGroup) => {
                // 處理 uni 模式下的項目展開與排序
                const expandedItems = _.flatMap(departureGroup.items, (item) =>
                  _.map(item.groups, (group) => ({
                    ...item,
                    groupDay: group.groupDay,
                    leaveDate: group.leaveDate,
                    sitePrice: group.sitePrice,
                    groups: [group],
                  })),
                );

                // 依據排序選項進行排序
                departureGroup.items = _.sortBy(expandedItems, (item) => {
                  if (sorts.date.active) {
                    const date = new Date(item.leaveDate);
                    return sorts.date.sort === "asc" ? date : -date;
                  }
                  if (sorts.price.active) {
                    return sorts.price.sort === "asc"
                      ? item.sitePrice
                      : -item.sitePrice;
                  }
                  if (sorts.day.active) {
                    return sorts.day.sort === "asc"
                      ? item.groupDay
                      : -item.groupDay;
                  }
                  return new Date(item.leaveDate);
                });
              });
            }

            // 移除暫存的映射物件
            delete otherArea.departureMap;
          });

          // 移除暫存的映射物件
          delete subAreaGroup.otherAreaMap;
        });

        // 移除暫存的映射物件
        delete areaGroup.subAreaMap;
      });

      return areaGroups;
    },

    createAllProductStructure(data, groupShowType, sorts) {
      if (!data || !Array.isArray(data.data)) return [];

      //先處理出發地
      data.data.forEach((item, index) => {
        item.departure =
          this.departureMap.AirPT[item.departure] || item.departure;
      });

      const processedItems =
        groupShowType === "uni"
          ? data.data
              .flatMap((item) =>
                item.groups.map((group) => ({
                  ...item,
                  groupDay: group.groupDay,
                  leaveDate: group.leaveDate,
                  sitePrice: group.sitePrice,
                  groups: [group],
                })),
              )
              .sort((a, b) => {
                if (sorts.date.active) {
                  const dateA = new Date(a.leaveDate);
                  const dateB = new Date(b.leaveDate);
                  return sorts.date.sort === "asc"
                    ? dateA - dateB
                    : dateB - dateA;
                }
                if (sorts.price.active) {
                  return sorts.price.sort === "asc"
                    ? a.sitePrice - b.sitePrice
                    : b.sitePrice - a.sitePrice;
                }
                if (sorts.day.active) {
                  return sorts.day.sort === "asc"
                    ? a.groupDay - b.groupDay
                    : b.groupDay - a.groupDay;
                }
                return new Date(a.leaveDate) - new Date(b.leaveDate);
              })
          : data.data;

      let result = {};
      if (data.type == "subArea" || data.type == "prom") {
        result = {
          subArea: data.subArea,
          otherAreaName: "全系列產品",
          departure: "",
          items: processedItems,
        };
      } else if (data.type == "departure") {
        result = {
          subArea: data.subArea,
          otherAreaName: data.otherAreaName,
          departure: data.departure, //
          items: processedItems,
        };
      }

      return result;
    },
    splitDeparture(groups) {
      let result = [];

      // 遍歷每個原始的 group 對象
      groups.forEach((originalGroup) => {
        // 根據 airport 屬性對 groups 進行分組
        const groupsByAirport = {};

        originalGroup.groups.forEach((groupItem) => {
          const airport = groupItem.airport;

          if (!groupsByAirport[airport]) {
            groupsByAirport[airport] = [];
          }

          groupsByAirport[airport].push(groupItem);
        });
        if (Object.keys(groupsByAirport).length === 0) {
          groupsByAirport["載入中"] = originalGroup.groups;
        }

        // 為每個機場創建一個新的 group 對象
        Object.keys(groupsByAirport).forEach((airport) => {
          // 使用解構賦值和展開運算符創建新對象
          const newGroup = {
            ...originalGroup,
            departure: airport, // 設置 departure 為對應的機場
            groups: groupsByAirport[airport], // 只保留對應機場的 groups
          };

          result.push(newGroup);
        });
      });
      return result;
    },
    transDeparture(groups, airports) {
      groups.forEach((group) => {
        group.departure =
          this.departureMap.AirPT[group.departure] || group.departure;
        if (this.departureMap.deptEng[group.departure]) {
          group.departureCode = this.departureMap.deptEng[group.departure];
        } else {
          //找不到就去airports找
          const data = airports.filter((v) => v.airpCnm == group.departure);
          if (data.length > 0) {
            group.departureCode = data[0].airpCd;
          } else {
            //如果還是沒有就給他XXX
            group.departureCode = "XXX";
          }
        }
        //group.departureCode = departureMap.deptEng[group.departure]
        group.departureSort =
          this.departureMap.AirSort[group.departure] || 9999;
      });
      return groups;
    },
    //整理優惠活動資料 最多只能有2個優惠活動 每個優惠活動最多8團
    transPromotion(promo, group) {
      const promMap = new Map();
      //const test = group.filter(g => promo.some((p) => p.classification == g.areaName))

      // 移除重複的 promName
      promo.forEach((obj) => {
        if (!promMap.has(obj.promName)) {
          promMap.set(obj.promName, obj);
        }
      });

      // 取得符合條件的前2筆 promotion
      const result = promo
        .filter(
          (obj) => obj.promName && group.some((v) => v.area == obj.promSn),
        )
        .map((obj) => {
          const matchedGroups = group
            .filter(
              (v) =>
                v.area == obj.promSn &&
                v.areaName == obj.classification &&
                v.type == "Prom",
            )
            // .map((v) => {
            //     // 過濾內層 groups
            //     const filteredInnerGroups = (v.groups || []).filter(
            //         (g) => new Date(g.leaveDate) >= new Date(obj.validSd) && new Date(g.leaveDate) <= new Date(obj.validEd)
            //     );
            //     return { ...v, groups: filteredInnerGroups };
            // })
            .filter((v) => v.groups.length > 0);

          return {
            prom: obj.promName,
            promSn: obj.promSn,
            sn: obj.sn,
            className: obj.classificationName,
            classification: obj.classification,
            groups: matchedGroups,
          };
        });

      // === 後處理 ===
      // 1. 移除 groups 為空的項目
      let filtered = result.filter(
        (item) => item.groups && item.groups.length > 0,
      );

      // 2. 合併相同 prom
      const map = new Map();
      for (const item of filtered) {
        if (!map.has(item.prom)) {
          map.set(item.prom, { ...item, groups: [...item.groups] });
        } else {
          const existing = map.get(item.prom);
          existing.groups = [...existing.groups, ...item.groups];
        }
      }

      // 3. 轉成陣列 & 只取前 2 筆
      let merged = Array.from(map.values()).slice(0, 2);

      // 4. 每筆 groups 只取前 8 筆
      merged = merged.map((item) => ({
        ...item,
        groups: item.groups
          .slice() // 複製避免改到原始陣列
          .sort((a, b) => {
            // 假設是數字排序，從小到大
            if (a.orderByValue < b.orderByValue) return -1;
            if (a.orderByValue > b.orderByValue) return 1;
            return 0;
          })
          .slice(0, 8),
      }));
      return merged;
    },
    //整理快速前往資料
    transQuick(quick, group, classificationOrders) {
      const validSubAreas = new Set(group.map((g) => g.subArea));

      const filteredQuick = quick.filter((item) =>
        validSubAreas.has(item.subClassification),
      );

      const groupedMap = filteredQuick.reduce((acc, item) => {
        const key = item.showClassNm || item.classificationName || "未分類";
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      const orderList = classificationOrders.split("|");
      const sortedResult = [];

      // 處理有順序的分類
      orderList.forEach((name) => {
        if (groupedMap[name]) {
          const items = groupedMap[name];
          sortedResult.push({
            classificationName: name,
            subClassification: items[0]?.subClassification || "", // ✅ 加這行
            items: items,
          });
          delete groupedMap[name];
        }
      });

      // 處理沒有指定順序的分類
      Object.keys(groupedMap).forEach((name) => {
        const items = groupedMap[name];
        sortedResult.push({
          classificationName: name,
          subClassification: items[0]?.subClassification || "", // ✅ 加這行
          items: items,
        });
      });

      // 排序每組 items
      sortedResult.forEach((group) => {
        group.items.sort((a, b) => a.orderByValue - b.orderByValue);
      });

      return sortedResult;
    },
    transFollowed(followed, group) {
      const result = [];

      for (const f of followed) {
        const matched = group.find((g) => g.mainGroupCode === f.mainGroupCode);
        if (matched) {
          result.push(matched);
        }
        if (result.length >= 6) break;
      }

      result.forEach((item) => {
        // 價格處理
        if (Array.isArray(item.groups) && item.groups.length > 0) {
          const minPrice = Math.min(...item.groups.map((g) => g.price));
          const minSitePrice = Math.min(...item.groups.map((g) => g.sitePrice));
          item.price = minPrice.toLocaleString();
          item.sitePrice = minSitePrice.toLocaleString();
        } else {
          item.price = "-";
          item.sitePrice = "-";
        }

        // 日期處理
        const allDates = [];
        item.groups?.forEach((g) => {
          if (typeof g.leaveDate === "string") {
            const parts = g.leaveDate.split("/"); // [yyyy, MM, dd]
            if (parts.length === 3) {
              const year = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10);
              const day = parseInt(parts[2], 10);
              allDates.push({
                str: `${month}/${day}`,
                date: new Date(year, month - 1, day), // 用真正的年份
              });
            }
          }
        });

        // 排序 + 去重
        const sortedDates = Array.from(
          new Set(
            allDates.sort((a, b) => a.date - b.date).map((d) => d.str), // 先轉字串，再去重
          ),
        );

        if (item.groups.length > 5 && sortedDates.length > 0) {
          const first = sortedDates[0];
          const last = sortedDates[sortedDates.length - 1];
          item.leaveDate = `${first}~${last}`;
        } else {
          item.leaveDate = sortedDates.join("、");
        }
      });

      return result;
    },
  };

  // 將服務掛載到全局
  window.transService = transService;
})();
